import { render, staticRenderFns } from "./MobileBottom.vue?vue&type=template&id=f2e90a08"
import script from "./MobileBottom.vue?vue&type=script&lang=js"
export * from "./MobileBottom.vue?vue&type=script&lang=js"
import style0 from "./MobileBottom.vue?vue&type=style&index=0&id=f2e90a08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports